module.exports = __webpack_public_path__ + "static/media/10.fee1a2bb.jpg";